import React from 'react'
import { ISocialMediaProps } from './types'
import IconList, { IconListItem } from '@/components/base/icon-list'
import { path, useApp } from '@wap-client/core'
import { GTMEvent } from '@/utils/gtm'

const SocialMedia: React.FC<ISocialMediaProps> = ({
  x,
  facebook,
  instagram,
  tiktok,
  youtube,
}) => {
  const app = useApp()

  return (
    <IconList className="social-media-list">
      <IconListItem
        icon={{
          name: 'instagram',
          onClick: (e) => {
            e.stopPropagation()
            e.preventDefault()
            window.open(
              instagram?.href ||
                app.settings.socials['instagram'] ||
                'https://www.instagram.com/goturkiye/',
              '_blank',
            )
          },
          style: { cursor: 'pointer' },
        }}
        text="instagram"
      />

      <IconListItem
        icon={{
          name: 'facebook',
          onClick: (e) => {
            e.stopPropagation()
            e.preventDefault()
            window.open(
              facebook?.href ||
                app.settings.socials['facebook'] ||
                'https://www.facebook.com/GoTurkiye',
              '_blank',
            )
          },
          style: { cursor: 'pointer' },
        }}
      />
      <IconListItem
        icon={{
          name: 'twitter-x',
          onClick: (e) => {
            e.stopPropagation()
            e.preventDefault()
            window.open(
              x?.href ||
                app.settings.socials['twitter'] ||
                'https://twitter.com/goturkiye',
              '_blank',
            )
          },
          style: { cursor: 'pointer' },
        }}
      />
      <IconListItem
        icon={{
          name: 'youtube',
          onClick: (e) => {
            e.stopPropagation()
            e.preventDefault()
            window.open(
              youtube?.href ||
                app.settings.socials['youtube'] ||
                'https://www.youtube.com/GoTürkiye',
              '_blank',
            )
          },
          style: { cursor: 'pointer' },
        }}
      />
      <IconListItem
        icon={{
          name: 'tik-tok',
          onClick: (e) => {
            e.stopPropagation()
            e.preventDefault()
            window.open(
              tiktok?.href ||
                app.settings.socials['pinterest'] ||
                'https://www.tiktok.com/@goturkiye',
              '_blank',
            )
          },
          style: { cursor: 'pointer' },
        }}
      />
    </IconList>
  )
}

export default SocialMedia
